import React, { useEffect, useState } from 'react';

import axios from 'axios';

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';

import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';

import get_device_metadata from '../utils/get_metadata';
import urlBase64ToUint8Array from '../utils/urlBase64ToUint8Array';

export const check_local_subscribe = async () => {
  // console.log('in checkSubscribe');
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    // console.log('in serviceworker');
    try {
      const registration = await navigator.serviceWorker.ready;

      // Request user permission for notifications
      // const permission = await Notification.requestPermission();
      // if (permission !== 'granted') {
      //   console.error('Notification permission not granted');
      //   return;
      // }

      const subscription = await registration.pushManager.getSubscription();
      // console.log(subscription);
      // return !!subscription;
      return subscription;
    } catch (error) {
      console.error('Error subscribing to push notifications:', error);
    }
  }
}

export const handle_new_subscription = async () => {
  // console.log('in handle new subscribe');
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    const registration = await navigator.serviceWorker.ready;
    const vapidPublicKey = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/notif/vapid_public_key`);
    // console.log('vapidPublicKey', vapidPublicKey.data);
    const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey.data);
    // console.log(convertedVapidKey);

    const new_sub = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey
    });

    await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/notif/sub`, {
      sub: new_sub,
      metadata: get_device_metadata()
    });
  }
}

export const get_notif_status = async (local_sub: PushSubscription) => {
  let res = null;
  try {
    res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/notif/notif_status`, { endpoint: local_sub.endpoint });
  } catch (error) {
    console.error('Error getting notification status:', error);
    // do some dialog thing here
    return false;
  }
  return res.data.notif_status;
}

export const update_notif_status = async (local_sub: PushSubscription) => {
  let res = null;
  try {
    res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/notif/update_status`, { endpoint: local_sub.endpoint });
  } catch (error) {
    console.error('Error getting notification status:', error);
    // do some dialog thing here
    return false;
  }
  return res.data.notif_status;
}

const Notif = () => {

  const [close_notif_check, set_close_notif_check] = useState<boolean>(false);
  const [local_sub, set_local_sub] = useState<PushSubscription | null | undefined>(null);
  const [notif_status, set_notif_status] = useState<boolean>(false);
  const [open_notif_alert, set_open_notif_alert] = useState<boolean>(false);

  const handle_toggle = async () => {
    // const local_sub = await check_local_subscribe();
    if (local_sub) {
      if (notif_status) {
        set_close_notif_check(true);
      } else {
        set_notif_status(true);
        await update_notif_status(local_sub);
        set_open_notif_alert(true);
      }
    } else {
      console.log('Not subscribed locally, subscribing now');
      await handle_new_subscription();
      const new_local_sub = await check_local_subscribe();
      set_local_sub(new_local_sub);
      set_notif_status(true);
      // set_open_notif_alert(true);
    }
  }

  useEffect(() => {
    const fetch_notif_status = async () => {
      const local_sub = await check_local_subscribe();
      set_local_sub(local_sub);
      if (local_sub) {
        // console.log('locally subscribed');
        let server_status = await get_notif_status(local_sub);
        set_notif_status(server_status);
      }
    }
    fetch_notif_status();
  }, [set_notif_status]);

  return (
    <>
      <IconButton onClick={handle_toggle}>
        {notif_status
          ? <NotificationsNoneIcon color='primary' />
          : <NotificationsOffIcon color='primary' />
        }
      </IconButton >
      <Dialog
        open={close_notif_check}
        onClose={() => set_close_notif_check(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle>確定要關閉通知嗎？</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button variant='outlined' onClick={() => set_close_notif_check(false)}>取消</Button>
          <Button variant='contained' autoFocus onClick={async () => {
            set_notif_status(false);
            if (local_sub) await update_notif_status(local_sub);
            set_close_notif_check(false);
          }}>確定</Button>
        </DialogContent>
      </Dialog>
      <Dialog
        open={open_notif_alert}
        onClose={() => set_open_notif_alert(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle>已開啟新影片通知！</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant='contained' onClick={() => set_open_notif_alert(false)}>知道了！</Button>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default Notif;